const es = {
  AuthTitle: {
    Greetings: "Bienvenido a",
  },
  Auth: {
    EnterEmail: "Introduce el correo electrónico",
    EnterPassword: "Introduce la contraseña",
    AgreeWith: "Estoy de acuerdo con",
    ProcessingPersonalData: "el procesamiento de datos personales",
    UserAgreement: "el acuerdo de usuario",
    EmailRequiredError: "El correo electrónico es obligatorio",
    EmailWrongFormatError: "Formato de correo electrónico incorrecto",
    PasswordRequiredError: "La contraseña es obligatoria",
    ForgotPassword: "¿Olvidaste tu contraseña?",
  },
  Login: {
    Title: "Autorización",
    Subtitle: "Complete los campos a continuación para acceder a su cuenta.",
    Login: "Iniciar sesión",
    Register: "Registro",
    LoginError: "Usuario o contraseña incorrectos",
    BuyTeacherLessons: "Comprar clases con un profesor",
  },
  Register: {
    Title: "Registro",
    Subtitle: "Complete los campos a continuación para registrar su cuenta.",
    Register: "Registro",
    Login: "Iniciar sesión",
    EnterLastName: "Introduce sus dos nombres",
    EnterFirstName: "Introduce sus dos apellidos",
    EnterEmail: "Introduce el correo electrónico",
    EnterGender: "Género",
    EnterBirthday: "Fecha de nacimiento",
    EnterProfileCountryId: "Cudadanía",
    EnterProfileCityId: "Сiudad y provincia de residencia",
    EnterProfileDegreeId: "Educación",
    EnterPassword: "Introduce la contraseña",
    RepeatPassword: "Repite la contraseña",
    LastNameRequiredError: "El apellido es obligatorio",
    LastNameMinLengthError: "Mínimo 2 caracteres",
    FirstNameRequiredError: "El nombre es obligatorio",
    FirstNameMinLengthError: "Mínimo 2 caracteres",
    PhoneRequiredError: "El teléfono es obligatorio",
    PhoneInvalidError: "Formato de teléfono incorrecto",
    GenderRequiredError: "El género es obligatorio",
    BirthdayRequiredError: "La fecha de nacimiento es obligatoria",
    ProfileCountryIdRequiredError: "La nacionalidad es obligatoria",
    ProfileCityIdRequiredError: "La ciudad de residencia es obligatoria",
    ProfileDegreeIdRequiredError: "La educación es obligatoria",
    PasswordMismatchError: "Las contraseñas no coinciden",
    PasswordMinLengthError: "Mínimo 6 caracteres",
  },
  Reset: {
    Title: "Restablecer contraseña",
    Subtitle:
      'Ingresa el correo electrónico que proporcionaste durante el registro y haz clic en el botón "Recuperar".',
    Reset: "Restaurar",
    Login: "Entrada",
    Success:
      "En unos minutos, recibirás un correo electrónico a <0>{{email}}</0> con instrucciones sobre cómo recuperar tu contraseña.",
  },
  CookieNotice: {
    Message:
      "Para mejorar el funcionamiento del sitio y su interacción con los usuarios, utilizamos archivos cookie. Al continuar usando el sitio, acepta el uso de cookies. Puede desactivar las cookies en la configuración de su navegador.",
    Agree: "Aceptar, no mostrar más",
  },
  MainPage: {
    Title: "Principal",
    TitleGreetings: "Bienvenido a",
    TitleGreetingsMiddle: "HABLA",
    TitleGreetingsEnd: "¡ES!",
    MyCourses: "Mis cursos",
    CourseContinue: "CONTINUAR",
    CourseCountStart: "Tiene acceso a",
    CourseCount_zero: "{{count}} cursos",
    CourseCount_one: "{{count}} curso",
    CourseCount_few: "{{count}} cursos",
    CourseCount_many: "{{count}} cursos",
    AllCourses: "Todos los cursos",
    MyLessons: "Mis lecciones",
    AllLessons: "todas las lecciones",
    EmptyCourses: "No hay cursos",
    EmptyLessons: "No hay lecciones",
    BuyTeacherLessons: "Comprar clases con un profesor",
    BuyTeacherLessonsLink: "aquí",
    ForeignCardTooltip: "Para tarjetas emitidas fuera de la Federación de Rusia",
    NoActiveLicense: "No tienes una licencia activa.",
    GoIntoLesson: "A la lección",
    FinishedLessons: "Completado",
    CanceledLessons: "CANCELADO",
  },
  CoursesPage: {
    Title: "Cursos",
    TitleGreetings: "Bienvenido a",
    MyCourses: "Mis cursos",
    CourseContinue: "CONTINUAR",
    EmptyCourses: "No hay cursos",
    SearchPlaceholder: "Buscar por nombre",
    LevelPlaceholder: "Nivel",
    AllLevels: "Todos los niveles",
  },
  Menu: {
    Main: "Página principal",
    Words: "Palabras",
    Courses: "Mis cursos",
    Lessons: "Lecciones con profesor",
    TeacherCorner: "Tareas creativas",
    AdditionalCourses: "Cursos adicionales",
    UsefulLinks: "Enlaces útiles",
    Notifications: "Notificaciones",
    Video: "Video",
    TeacherGroups: "Grupos",
    TeacherAttendance: "Asistencia",
    TeacherClasses: "Clases",
    TeacherReports: "Informes",
    CreativeTasks: "Tareas creativas",
    Attendance: "Asistencia",
  },
  Footer: {
    Copyright: "Todos los derechos reservados",
    About: "Sobre la empresa",
    PrivacyPolicy: "Política de uso de datos",
    PrivacyProtect:
      "Reglamento sobre el tratamiento y protección de datos personales",
  },
  Module: {
    exercise_one: "ejercicio",
    exercise_two: "ejercicios",
    exercise_few: "ejercicios",
    Completed: "Completado",
    Result: "Resultado",
    InWork: "En progreso",
    Done: "Terminado",
  },
  SteppedProgress: {
    Completed: "Completado",
  },
  CourseDetails: {
    Title: "Información del curso",
    Progress: "Progreso",
    Completed: "COMPLETADO",
    Result: "RESULTADO",
    Hours: "Horas",
    Lessons: "Lecciones",
    Units: "Unidades",
    Unit: "Unidad",
    Exercises_zero: "{{count}} ejercicios",
    Exercises_one: "{{count}} ejercicio",
    Exercises_few: "{{count}} ejercicios",
    Exercises_many: "{{count}} ejercicios",
  },
  CourseUnitDetails: {
    Vocabulary: "Vocabulario",
    Video: "Video",
    Grammar: "Gramática",
    Reading: "Lectura",
    Writting: "Escritura",
    Speaking: "Conversación",
    Test: "Prueba",
    Unknown: "Desconocido",
    EmptyExercises: "No hay ejercicios",
  },
  EntranceTest: {
    ModalTitle: "Determina tu nivel de conocimiento",
    ModalBody:
      "Realiza la prueba para determinar tu nivel de competencia en ruso. El tiempo estimado es de 40 minutos.",
    Cancel: "Cancelar",
    Take: "Ir a la tarea",
  },
  TeacherPage: {
    Title: "Página principal del profesor",
    MyLessons: "Mis lecciones",
    MyModules: "Mis módulos",
  },
  DistributorPage: {
    Title: "Página principal del distribuidor",
  },
  CoordinatorPage: {
    Title: "Página principal del coordinador",
  },
  Distributor: {
    Report: "Informes",
    DateFrom: "Desde la fecha",
    DateTo: "Hasta la fecha",
    Status: "Estado",
    StatusReady: "Listo",
    StatusPlanned: "En procesamiento",
    Actions: "Acciones",
    FromRequiredError: "Indica la fecha de inicio",
    ToRequiredError: "Indica la fecha de finalización",
  },
  Button: { Send: "Enviar", Download: "Descargar" },
  LessonsTable: {
    GroupName: "Grupos",
    Status: "Estado",
    StartDateTime: "Fecha y hora",
    Duration: "Horas académicas",
    Credentials: "Webinar: Usuario/Contraseña",
    CredentialsCopied: "¡Copiado!",
    SortAlpabetically: "Ordenar alfabéticamente A-Z",
  },
  LessonStatuses: {
    completed: "Completado",
    planned: "Programado",
    earlyCanceledByCustomer: "Cancelado por los estudiantes",
    earlyCanceledBySchool: "Cancelado por el profesor",
    lateCanceledByCustomer: "Cancelado por los estudiantes",
    lateCanceledBySchool: "Cancelado por el profesor",
    notPerformedToPay: "Para pagar",
  },
  LessonAttendance: {
    Status: "Seleccione el estado",
    Date: "Seleccione la fecha",
    Time: "Seleccione la hora",
    Duration: "Duración",
    AH: "horas académicas",
    Students: "Estudiantes",
    CheckAll: "Marcar todos",
    Comment: "Comentario",
    Submit: "Listo",

    restrictiveBackDateError: "La fecha no puede ser anterior a la permitida",
    restrictiveForwardDateError:
      "La fecha no puede ser posterior a la permitida",
    commentSizeError: "El comentario debe tener menos de {{count}} palabras",
    requiredFieldError: "Este campo es obligatorio",
    requiredDateError: "Rellene la fecha y la hora",
    ExcessHoursWarning: "Cantidad de horas excedida",
    MarkStudents:
      "Marque los estudiantes que asistieron a la clase y guarde los cambios.",

    apiError:
      "Sus cambios no se han guardado. Por favor escriba a online@dschool.ru",
    early_cancel_by_customer_not_acceptable:
      "La cancelación anticipada por el usuario no está disponible; ya se han cancelado 2 clases, contacte con el coordinador",
    early_cancel_by_school_not_acceptable:
      "La cancelación anticipada por la escuela no está disponible; ya se han cancelado 2 clases, contacte con el coordinador",
  },
  TeacherReportsPage: {
    Title: "Informes",
    HeaderTitle: "Informes",
    CreateReport: "crear informe",
  },
  TeacherReportTable: {
    Title: "Nombre del informe",
    CreationDate: "Fecha de creación",
    Period: "Período",
    Status: "Estado",
    StatusDone: "completo",
    StatusPending: "en construcción",
    Actions: "Acciones",
    Statistics: "Estadísticas de la plataforma",
    CourseProgress: "Progreso del curso",
    ActiveTime: "Informe de tiempo en la plataforma",
    EntranceTest: "Prueba de ingreso",
    LecenseReport: "Informe de licencias utilizadas",
    HeaderTitle: "Informes",
    CreateReport: "Crear informe",
    DeleteReport: "¿Está seguro?",
    DeleteTooltip: "Eliminar",
    MailTooltip: "Enviar por correo",
    DownloadTooltip: "Descargar",
    DeleteGroupTooltip: "Eliminar seleccionados",
    MailGroupTooltip: "Enviar seleccionados por correo",
    DownloadGroupTooltip: "Descargar seleccionados",
  },
  CreateReportForm: {
    Statistics: "Estadísticas de la plataforma",
    CourseProgress: "Progreso del curso",
    ActiveTime: "Informe de tiempo en la plataforma",
    Report: "Mi informe",
    Title: "Creación de informe",
    Type: "Tipo de informe",
    TypeLabel: "Tipo",
    NameLabel: "Nombre",
    DateLabel: "Fecha",
    DateFromLabel: "Desde",
    DateToLabel: "Hasta",
    Name: "Nombre del informe",
    Period: "Período",
    PeriodFrom: "Desde",
    PeriodTo: "Hasta",
    Date: "Fecha",
    FilterListGroup: "Grupo",
    FilterListStudent: "Estudiante",
    FilterListCompany: "Empresa cliente",
    FilterListTest: "Nombre del informe de ingreso",
    FilterListSelectedStudents:
      "Filtro de grupos, seleccionados {{count}} estudiantes",
    FilterListSelectedGroups:
      "Filtro de grupos, seleccionados {{count}} grupos",
    FilterListSelectedCompanies:
      "Filtro de grupos, seleccionados {{count}} empresas",
    FilterListSelectedTests:
      "Filtro de grupos, seleccionados {{count}} pruebas de ingreso",
    FilterListSelectedPlaceholderStudents: "Seleccionar estudiantes",
    FilterListSelectedPlaceholderGroups: "Seleccionar grupos",
    FilterListSelectedPlaceholderCompanies: "Seleccionar empresas clientes",
    FilterListSelectedPlaceholderTests: "Seleccionar pruebas de ingreso",
    GroupsChosen: "Grupos seleccionados",
    ChooseAll: "Seleccionar todo",
    RemoveAll: "Eliminar todo",
    GroupName: "Grupo",
    GroupDefault: "Agrupar por defecto",
    Cancel: "Cancelar",
    Create: "Crear",
    TitleRequiredError: "Se requiere un título",
    FromRequiredError: "Indique la fecha de inicio del período",
    ToRequiredError: "Indique la fecha de finalización del período",
    GroupsRequiredError: "¡Seleccione uno o varios grupos!",
    OrderCreateError: "No se pudo crear el nuevo informe",
    FieldRequiredError: "Campo obligatorio",
    NoItems: "No hay grupos",
  },
  Gender: {
    Male: "Masculino",
    Female: "Femenino",
  },
  Role: {
    student: "Estudiante",
    teacher: "Profesor",
    distributor: "Distribuidor",
    coordinator: "Coordinador",
  },
  EmailNotConfirmed: {
    Title:
      "Se ha enviado un correo electrónico de confirmación a {{email}} para acceder a la plataforma. Por favor, confirme su dirección. Si tiene preguntas, escríbanos a online@dschool.ru",
    Back: "<< Volver",
  },
  MyWordsPage: {
    Title: "Mis palabras",
    EmptyWordList:
      "No hay palabras para estudiar. Seleccione otra sección en los filtros",
  },
  WordsFilter: {
    Title: "Filtros",
    Clear: "Borrar",
    EmptyCourses: "Lista de cursos vacía",
    ChooseCourse: "Seleccione un curso",
    ChooseUnit: "Seleccione una unidad",
    EmptyUnits: "Lista de unidades vacía",
  },
  SetupPassword: {
    Title: "Configurar contraseña",
    Subtitle:
      "Debe configurar una nueva contraseña. Introduzca la nueva contraseña y la confirmación en los campos a continuación",
  },
  SetupPasswordRedirect: {
    Title: "Acción requerida",
    Description:
      "Debe establecer una contraseña para continuar utilizando este servicio",
    Redirect: "Establecer contraseña",
  },
  ChangePassword: {
    Password: "Contraseña",
    PasswordRepeat: "Confirmar contraseña",
    Confirm: "Confirmar",
    PasswordShortError: "La contraseña debe tener más de 6 caracteres",
    PasswordMismatch: "Las contraseñas deben coincidir",
    Success: "Contraseña cambiada con éxito",
    Login: "A la página de autorización",
  },
  ProfilePage: {
    Title: "Mi perfil",
  },
  Profile: {
    PersonalData: "Información personal",
    FirstName: "Nombre",
    LastName: "Apellido",
    BirthDate: "Fecha de nacimiento",
    Citizenship: "Ciudadanía",
    Degree: "Educación",
    City: "Ciudad de residencia",
    NewPassword: "Nueva contraseña",
    ConfirmNewPassword: "Confirmar nueva contraseña",
    Password: "Contraseña",
    Save: "Guardar",
    DataUpdateSuccess: "Datos actualizados con éxito",
    Settings: "Configuración",
    ShowPassingResults: "Mostrar resultados de aprobación",
  },
  UsefulLinks: {
    Title: "Enlaces útiles",
    GroupName: "Grupo de estudio:",
    Added: "Añadido",
    NoLinks: "No hay enlaces",
  },
  DatePicker: {
    Today: "Hoy",
    Clear: "Borrar",
  },
  Promocode: {
    Expired:
      "La inscripción al grupo ha finalizado. Póngase en contacto con su gestor",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "No se encontraron profesores",
    SelectTeacher: "Seleccionar profesor",
  },
  Loading: {
    Error: "Error al cargar, intente actualizar la página",
  },
  MultipleSelect: {
    SelectAll: "Seleccionar todo",
  },
  Attendance: {
    Title: "Asistencia",
  },
};

export default es;
